document.addEventListener('DOMContentLoaded', () => {
    const HEADER_OFFSET = 80;

    const toggleButton = document.querySelector('.menu-toggle');
    const menu = document.querySelector('.main-menu-container');

    toggleButton.addEventListener('click', () => {
        menu.classList.toggle('active');
    });

// Optionnel : toggle sous-menus sur mobile
    menu.querySelectorAll('.menu-item-has-children > a').forEach(link => {
        link.addEventListener('click', e => {
            if (window.innerWidth <= 768) {
                e.preventDefault(); // empêche le lien de naviguer
                const parent = link.parentElement;
                parent.classList.toggle('active');
            }
        });
    });


    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            const targetId = this.getAttribute('href');

            // liens vides ou # : on bloque le saut en haut de page
            if (targetId === '#' || targetId === '') {
                e.preventDefault();
                return;
            }

            const target = document.querySelector(targetId);
            if (!target) return;

            e.preventDefault();

            const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = targetPosition - HEADER_OFFSET;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        });
    });
});
